'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarMain = renderWithRef('PriceBarMain', null, (a, o)=>{
    let { children: n } = a;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: new Set([
            'swan-price-bar-main'
        ]),
        props: a,
        children: n
    });
});

export { PriceBarMain };
